import { render, staticRenderFns } from "./Stat.vue?vue&type=template&id=84ed6508"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"
import style0 from "./Stat.vue?vue&type=style&index=0&id=84ed6508&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports